<template>
  <div class="status-banner d-flex align-items-center" :class="statusColorClass">
    <div class="circle-icon-background me-3" :class="iconColorClass">
      <i :class="icon" />
    </div>

    <div>
      {{ text }}
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },

    status: {
      type: String,
      required: false,
      default: 'default'
    },

    text: {
      type: String,
      required: true
    }
  },

  computed: {
    iconColorClass() {
      switch (this.status) {
      case 'success':
        return 'icon-success'
      case 'danger':
        return 'bg-danger'
      default:
        return 'bg-primary'
      }
    },

    statusColorClass() {
      switch (this.status) {
      case 'success':
        return 'status-success'
      case 'danger':
        return 'status-danger'
      default:
        return 'bg-primary-translucent'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-banner {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 30px;

  &.status-success {
    background-color: #d5ecdb;
  }

  &.status-danger {
    background-color: #f8d7da;
  }

  .circle-icon-background {
    width: 51px;
    height: 51px;
    border-radius: 50%;
    text-align: center;
    color: white;
    font-size: 35px;

    &.icon-success {
      background-color: #51a266;
    }
  }
}
</style>
